import qs from 'query-string';
import { isoDateToString } from './index';
import { routes } from 'Constants';

/**
 * Genera un mensaje contextual para WhatsApp basado en la ruta y parámetros actuales
 * @param {string} pathname - Ruta actual
 * @param {string} search - Query string actual
 * @returns {string} Mensaje contextual para WhatsApp
 */
export const generateWhatsAppMessage = (pathname, search) => {
  const queryParams = qs.parse(search);
  const pathParts = pathname.split('/').filter(Boolean);

  // CHECKOUT
  if (pathname.includes('/checkout')) {
    return 'Consulta sobre mi reserva';
  }

  // PAQUETES
  if (pathname.includes('/promociones-en-paquetes-vacacionales')) {
    // Paquete específico: /promociones-en-paquetes-vacacionales/paquete/:keyword/:id
    if (pathname.includes('/paquete/')) {
      const keywordIndex = pathParts.indexOf('paquete');
      const keyword = pathParts[keywordIndex + 1];
      const destination = keyword ? keyword.replace(/-/g, ' ') : '';

      // Si tiene fecha en query params
      if (queryParams.start || queryParams.date) {
        const date = queryParams.start || queryParams.date;
        const formattedDate = isoDateToString(date);
        if (queryParams.end) {
          const formattedEndDate = isoDateToString(queryParams.end);
          return `Consulta sobre paquete a ${destination} del ${formattedDate} al ${formattedEndDate}`;
        }
        return `Consulta sobre paquete a ${destination}${formattedDate ? ` para el ${formattedDate}` : ''}`;
      }

      return `Consulta sobre paquete a ${destination}`;
    }

    // Listado de paquetes con filtros
    if (Object.keys(queryParams).length > 0) {
      const filters = [];
      
      if (queryParams.donde) {
        filters.push(`en ${queryParams.donde}`);
      }
      
      if (queryParams.cuando) {
        filters.push(`en ${queryParams.cuando}`);
      }
      
      if (queryParams.como) {
        filters.push(queryParams.como);
      }

      const filtersText = filters.length > 0 ? ` ${filters.join(', ')}` : '';
      return `Consulta sobre paquetes vacacionales${filtersText}`;
    }

    return 'Consulta sobre paquetes vacacionales';
  }

  // VUELOS
  if (pathname.includes('/vuelos-baratos-internacionales') || pathname.includes('/vuelos-multidestino')) {
    if (queryParams.from && queryParams.to) {
      const from = queryParams.from.toUpperCase();
      const to = queryParams.to.toUpperCase();
      
      if (queryParams['from-date']) {
        const formattedDate = isoDateToString(queryParams['from-date']);
        if (queryParams['to-date']) {
          const formattedReturnDate = isoDateToString(queryParams['to-date']);
          return `Consulta sobre vuelos de ${from} a ${to} ida ${formattedDate} vuelta ${formattedReturnDate}`;
        }
        return `Consulta sobre vuelos de ${from} a ${to} para el ${formattedDate}`;
      }
      
      return `Consulta sobre vuelos de ${from} a ${to}`;
    }

    // Si está en una página de destino con vuelos
    if (pathParts.length > 0 && pathParts[0] !== 'vuelos-baratos-internacionales' && pathParts[0] !== 'vuelos-multidestino') {
      const destination = pathParts[0].replace(/-/g, ' ');
      if (queryParams['from-date']) {
        const formattedDate = isoDateToString(queryParams['from-date']);
        return `Consulta sobre vuelos a ${destination} para el ${formattedDate}`;
      }
      return `Consulta sobre vuelos a ${destination}`;
    }

    return 'Consulta sobre vuelos';
  }

  // HOTELES
  if (pathname.includes('/hoteles-baratos-y-ofertas')) {
    // Detalle de hotel: /:destination/:nameHotel
    if (pathParts.length >= 2 && !pathParts.includes('hoteles-baratos-y-ofertas')) {
      const destination = pathParts[0].replace(/-/g, ' ');
      const hotelName = pathParts[1].replace(/-/g, ' ');
      
      if (queryParams['from-date'] && queryParams['to-date']) {
        const checkIn = isoDateToString(queryParams['from-date']);
        const checkOut = isoDateToString(queryParams['to-date']);
        return `Consulta sobre hotel ${hotelName} en ${destination} del ${checkIn} al ${checkOut}`;
      }
      
      return `Consulta sobre hotel ${hotelName} en ${destination}`;
    }

    // Búsqueda de hoteles
    if (queryParams.to || (pathParts.length > 0 && pathParts[0] !== 'hoteles-baratos-y-ofertas')) {
      const destination = queryParams.to 
        ? queryParams.to.replace(/-/g, ' ')
        : pathParts[0].replace(/-/g, ' ');
      
      if (queryParams['from-date'] && queryParams['to-date']) {
        const checkIn = isoDateToString(queryParams['from-date']);
        const checkOut = isoDateToString(queryParams['to-date']);
        return `Consulta sobre hoteles en ${destination} del ${checkIn} al ${checkOut}`;
      }
      
      return `Consulta sobre hoteles en ${destination}`;
    }

    return 'Consulta sobre hoteles';
  }

  // DESTINOS
  if (pathParts.length === 1 && !pathParts[0].includes('blog') && !pathParts[0].includes('checkout')) {
    const destination = pathParts[0].replace(/-/g, ' ');
    return `Consulta sobre ${destination}`;
  }

  // BLOG
  if (pathname.includes('/blog')) {
    return 'Consulta sobre el blog';
  }

  // SEGURO DE VIAJE
  if (pathname.includes('/asistencias')) {
    return 'Consulta sobre seguro de viaje';
  }

  // DEFAULT
  return 'Hola, me gustaría recibir más información';
};

